import { render, staticRenderFns } from "./BillCredit.vue?vue&type=template&id=166ec000&lang=pug"
import script from "./BillCredit.vue?vue&type=script&lang=js"
export * from "./BillCredit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports